module.exports = __webpack_public_path__ + "bd6a836d1739dde5c2508949bcafa290.png";